import React from "react";
const SubmitButton = ({ label }) => {
    return (
        <div style={{marginTop: 10, textAlign: 'center'}} className="upload-btns">
            <button type="submit" className="signup-btn">{label}</button>
        </div>
    )
}
export default SubmitButton;